interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  accent?: "primary" | "secondary" | "accent";
}

const accentMap = {
  primary: "bg-primary-500",
  secondary: "bg-secondary-500",
  accent: "bg-accent-500",
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  accent = "primary",
}: SectionHeadingProps) {
  return (
    <div className="max-w-3xl">
      <div className="flex items-center gap-2">
        <span className={`h-4 w-1 rounded-full ${accentMap[accent]}`} />
        <span className="font-label text-xs font-medium uppercase tracking-[0.22em] text-foreground-500">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {description ? (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          {description}
        </p>
      ) : null}
    </div>
  );
}